<template>
    <modal :open="open" @close="$emit('close')" title="Add Articles to Block" class="modal--dark">

        <div class="filter-box">
            <div class="filter-box__left">
                <div class="search-box">
                    <input type="text" v-model="searchTerm" placeholder="Filter Articles...">
                </div>
            </div>
            <div class="filter-box__right">

                <a class="button" v-if="listManager.selectedIds.length>0" @click="saveArticles()">Add {{listManager.selectedIds.length}} Articles</a>
                <a class="button" v-if="listManager.selectedIds.length==0" @click="newArticle()" v-t="'New Article'"></a>
            </div>
        </div>

        <h3 class="modal__content__noarticles" v-if="articles.length==0" v-t="'No matching articles :('"></h3>

        <div class="modal__content__articles">
            <div class="modal__content__articles__inner">
                <table class="editor-table editor-table--full" style="border-top: 1px solid #ddd;">
                    <tbody data-as-sortable="board.dragControlListeners" data-v-model="page.article_set">
                        <tr v-bind:key="article.id" v-for="article in articles" @click="addArticle($event, article)" :class="{'greyed-out': !article.published}" >
                            <td width="100%">
                                <div v-if="article.image" class="img" :style="{'background-image': 'url('+article.image.image+')'}">
                                    <div class="checked" v-if="listManager.selectedIds.indexOf(article.id) > -1"></div>
                                </div>
                                <div v-if="!article.image" class="img" >
                                    <div class="checked" v-if="listManager.selectedIds.indexOf(article.id) > -1"></div>
                                </div>
                                <div class="img-text">
                                    <a class="ellipsis">{{article.title}}</a>
                                    <span class="ellipsis grey">{{article.publication_name}} &bullet; {{article.published_date}}
                                        <span v-if="!article.published">&bullet; <span v-t="'Not Published'"></span></span>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </modal>

</template>

<script>
    import Modal from '@/components/Modal.vue'
    import listService from '@/services/listService.js';

    export default {
        props: ['open', 'articleIDs'],
        components: {
            Modal
        },
        data () {
            return {
                searching: false,
                searchTerm: '',
                articles: [],
                errors: {},
                listManager:  new listService([]),
            }
        },
        methods: {
            newArticle () {
                this.$emit('close')
                this.$parent.$parent.addArticle()
            },
            saveArticles () {
                this.$emit('close', this.listManager.selectedItems)
            },
            addArticle ($event, article) {
                if(!article.published){
                    return;
                }

                this.listManager.toggle($event, article)
            }
        },
        watch: {
            searchTerm (term) {
                if (term !== ''){
                    this.searching = true;
                    this.$http.get('/articles/?exclude='+this.articleIDs+'&search='+term).then(data => {
                        this.articles = data.data;
                        this.listManager = new listService(this.articles)
                    });
                }else{

                    this.searching = false;
                    this.$http.get('/articles/?exclude='+this.articleIDs).then(data => {
                        this.articles = data.data;
                        this.listManager = new listService(this.articles)
                    });
                }
            },
            open () {
                this.$http.get('/articles/?exclude='+this.articleIDs).then(data => {
                    this.articles = data.data
                    this.listManager = new listService(this.articles)
                });
            }
        },
        mounted () {
            this.$http.get('/articles/?exclude='+this.articleIDs).then(data => {
                this.articles = data.data
                this.listManager = new listService(this.articles)
            });
        }
    }
</script>

